import { CustomHeader } from 'components/universal/custom-header';
import { useTranslation } from 'react-i18next';
import { DownloadView } from 'views/download';

export const Download = () => {
    const { t } = useTranslation('', {
        keyPrefix: 'SEO.download',
    });

    return (
        <>
            <CustomHeader title={t('title')} />
            <DownloadView />
        </>
    );
};
